<template>
    <b-modal
        id="modal-assignment-review"
        ref="modal-assignment-review"
        centered
        ok-only
        ok-title="Cerrar"
        ok-variant="secondary"
        size="lg"
        title="Revisar Archivos de Entrega"
        @show="loadAvailableAssignmentFiles()"
        @hidden="resetForm()"
    >
        <!-- Assignment Information -->
        <div v-if="selectedAssignment">
            <h4>
                {{ selectedAssignment.name }}
                <b-button
                    :href="allFilesDownloadUrl"
                    class="ml-2"
                    variant="primary"
                >
                    <b-icon-download /> Descargar Todos
                </b-button>
            </h4>
            <h5>
                Fecha límite:
                <strong :class="selectedAssignment.class">
                    {{ selectedAssignment.displayDeadlineDate }}
                </strong>
            </h5>
            <h5>
                Tamaño máximo: <strong>{{ this.maxSizeInMB }}</strong> MB
            </h5>
        </div>
        <hr />
        <div
            v-if="!dataLoaded"
            class="text-center"
        >
            <b-spinner
                label="Cargando..."
                variant="primary"
            />
            <h5>Cargando archivos...</h5>
        </div>
        <div v-else-if="assignmentFiles">
            <b-tabs active-nav-item-class="bg-primary text-white">
                <b-tab
                    v-for="(fileRows, studentSection) in assignmentFiles"
                    :key="`section-${studentSection}`"
                    :title="studentSection"
                >
                    <b-table
                        hover
                        responsive
                        striped
                        :items="fileRows"
                        :fields="columnFields"
                        :sort-by="'fullName'"
                        :sort-desc="false"
                    >
                        <template v-slot:cell(actions)="data">
                            <span>
                                <b-button
                                    :href="data.item.downloadUrl"
                                    variant="primary"
                                    size="sm"
                                >
                                    <b-icon-download /> ({{ data.item.size }})
                                </b-button>
                            </span>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
        </div>
        <h5 v-else>
            No se han subido archivos de entrega.
        </h5>
    </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { getSpanishLocaleDateFormat } from '@/helpers.js'

export default {
    name: 'AssignmentReviewModal',
    data () {
        return {
            dataLoaded: false,
            currentFilesBySection: null,
            columnFields: [
                { key: 'idCardNumber', label: 'Cédula', sortable: true },
                { key: 'fullName', label: 'Estudiante', sortable: true },
                { key: 'latestUpdateDate', label: 'Última actualización', sortable: true },
                { key: 'actions', label: 'Descarga' }
            ]
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'userToken',
            'selectedAssignment'
        ]),
        ...mapGetters([
            'getActiveSiteSectionOptions'
        ]),
        maxSizeInMB () {
            if (this.selectedAssignment) {
                return (this.selectedAssignment.maxSize / (1024 * 1024)).toFixed(0)
            }
            return ''
        },
        allFilesDownloadUrl () {
            return `${process.env.VUE_APP_API_URL}/sites/${this.activeSite.id}` +
            `/assignments/${this.selectedAssignment.id}/files/download?token=${this.userToken}`
        },
        assignmentFiles () {
            if (!this.currentFilesBySection) return null
            let sections = Object.keys(this.currentFilesBySection).sort()
            console.log({ sections })
            if (this.currentFilesBySection && this.getActiveSiteSectionOptions && sections.length) {
                var formattedFiles = {}
                sections.map(sectionName => {
                    formattedFiles[sectionName] = this.currentFilesBySection[sectionName].map((assngFile) => {
                        return {
                            id: assngFile.file_id,
                            idCardNumber: assngFile.identity_card,
                            fullName: `${assngFile.lastname}, ${assngFile.name}`,
                            size: this.getDisplayFileSize(assngFile.file_size),
                            latestUpdateDate: getSpanishLocaleDateFormat(assngFile.file_updated_at),
                            downloadUrl: `${process.env.VUE_APP_API_URL}/sites/${this.activeSite.id}` +
                                `/assignments/${this.selectedAssignment.id}/files/${assngFile.file_id}` +
                                `?token=${this.userToken}`
                        }
                    })
                })
                return formattedFiles
            }
            return null
        }
    },
    methods: {
        ...mapActions([
            'readAllFilesFromAssignment'
        ]),
        getDisplayFileSize (sizeInBytes) {
            if (sizeInBytes) {
                if (sizeInBytes > 1024 * 1024) {
                    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`
                } else {
                    return `${(sizeInBytes / 1024).toFixed(2)} KB`
                }
            }
        },
        async loadAvailableAssignmentFiles () {
            try {
                let payload = { courseSiteId: this.activeSite.id, assignmentId: this.selectedAssignment.id }
                this.currentFilesBySection = await this.readAllFilesFromAssignment(payload)
            } catch (err) {
                console.log({ err: err })
                this.$root.unknownErrorToast()
                this.currentFilesBySection = null
            } finally {
                this.dataLoaded = true
            }
        },
        resetForm () {
            this.dataLoaded = false
            this.currentFilesBySection = null
            this.$store.commit('RESET_SELECTED_ASSIGNMENT')
        }
    }
}
</script>
